module.exports = __webpack_public_path__ + "static/img/14000068.0d51b5dd.png";